<div  [ngClass]="isFranchisee?'card1FranchiseeCustom':'card1'">
    <!-- <div class="row breadcrumb">
        <div class="col-md-12">
            <span class="b-left" (click)="back()">
                <mat-icon>keyboard_arrow_left</mat-icon>
                <span>Project Details</span>
            </span>
        </div>
    </div> -->
    <div class="row">
        <div class="col-md-6">
            <h4 class="versions-heading font700">Daily Log List</h4>
        </div>
        <div class="col-md-6 text-end gap-4">
            <button mat-raised-button color="primary" (click)="navigateToDailyLog()"
                class="new-log marginLeftCustomCreate" [disabled]="isFranchisee || activeSubTab === 'closed'">Create Daily Log</button>
            <button mat-stroked-button color="primary" (click)="selectAllLogs()" *ngIf="!allSelected"
                [disabled]="isFranchisee">Select
                All</button>
            <button mat-stroked-button color="primary" (click)="deSelectAllLogs()" *ngIf="allSelected"
                [disabled]="isFranchisee">Deselect
                All</button>
            <button mat-raised-button color="primary" (click)="downloadSelected()"
                [disabled]="noneSelected  || isFranchisee" class="marginLeftCustom"
                matTooltip="Download selected logs as pdf"><mat-icon>download</mat-icon>
                Download selected</button>
        </div>
    </div>

    <ng-container *ngIf="allLogs?.length>0">
        <div class="dl-detail" *ngFor="let log of allLogs;let i=index">
            <div class="mb-2 badge-div">
                <span class="badge"
                    [ngClass]="log?.type === 1 ? 'bg-gold' : log?.type ===2? 'bg-theme-green':'bg-theme-blue'">
                    {{ log?.type === 1 ? 'Contractor' : (log?.type === 2?'Customer':'Franchisee') }}
                </span>
            </div>
            <div class="full-width d-flex">
                <div class="leftSection">
                    <mat-checkbox [(ngModel)]="selected[i]" (ngModelChange)="onSelectedLogChange(i, $event)"
                        [disabled]="isFranchisee"></mat-checkbox>
                </div>
                <div class="rightSection">
                    <div class="row">
                        <div class="col-md-4">
                            <h4 class="title">Log Title</h4>
                            <h4 class="title2">{{log?.log_title}}</h4>
                        </div>
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-auto">
                                    <h4 class="title">Weather Conditions</h4>
                                    <h4 class="title2">
                                        {{(log?.weatherDetails[0]?.weather_details?.weather_desc||'---')|titlecase}}
                                    </h4>
                                </div>
                                <div class="col-md custom-left-no-pad">
                                    <div *ngFor="let weather of log?.weatherDetails" class="outer_box">
                                        <div class="temp_box">
                                            <div class="img-temp-box">
                                                <img [src]="getIconUrl(weather?.icon)">
                                            </div>
                                            <div>
                                                <h4 class="font14 font600 mb-0 mt-0" matTooltip="Actual Temperature" *ngIf="weather?.temp">
                                                    {{weather?.temp}}&deg;C
                                                </h4>
                                                <p class="font13 mb-0 feels_like" matTooltip="Feels like" *ngIf="weather?.weather_details?.feel_like_temp">
                                                    {{weather?.weather_details?.feel_like_temp}}&deg;C</p>
                                            </div>
                                        </div>
                                        <div class="ext_details">
                                            <div class="icon_para_outer">
                                                <p matTooltip="Location" class="icon_para mb-0">
                                                    <mat-icon class="icon_location my-mat-icons">location_on</mat-icon>
                                                    <span class="font13">{{weather?.location}}</span>
                                                </p>
                                                <p matTooltip="Wind Speed" class="icon_para mb-0" *ngIf="weather?.weather_details?.wind_speed"><mat-icon
                                                        class="icon_wind_speed my-mat-icons">air</mat-icon>
                                                    <span
                                                        class="font13">{{weather?.weather_details?.wind_speed}}mph</span>
                                                </p>
                                                <p matTooltip="Humidity" class="icon_para mb-0" *ngIf="weather?.weather_details?.humidity"><mat-icon
                                                        class="icon_humidity my-mat-icons">water_drop</mat-icon>
                                                    <span class="font13">{{weather?.weather_details?.humidity}}%</span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2 text-right">
                            <div class="pdf-icon-div mb-2">
                                <div class="rounded-button" matTooltip="Download this log as PDF"
                                    (click)="downloadSingleLog(i)" [ngClass]="isFranchisee?'disable-class':''">
                                    <mat-icon class=" down-pdf-icon">download</mat-icon>
                                </div>
                            </div>
                            <h6 class="title">Created by</h6>
                            <h6 class="title2 marginLeftCustom">{{log?.created_by_name}}</h6>
                        </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="col-md-7">
                            <ng-container *ngIf="log?.log_description">
                                <h4 class="title">Description</h4>
                                <h4 class="title2 white-space-pre">{{log?.log_description}}</h4>
                            </ng-container>
                        </div>
                        <div class="col-md-5">
                            <div class="row">
                                <div class="col-md-9 text-right" *ngIf="log?.date_related">
                                    <h6 class="title"> Daily log relates to</h6>
                                    <h6 class="title2 mb-0">{{log?.date_related | date}}</h6>
                                </div>
                                <div class="text-right" [ngClass]="log?.date_related?'col-md-3':'col-md-12'">
                                    <h6 class="title">Created at</h6>
                                    <h6 class="title2 mb-0">{{log?.created_at | date}}</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <mat-accordion class="custom-accordion">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title><span class="title">Comments</span>
                                            <mat-icon class="marginLeftCustom" color="primary"
                                                (click)="openDialog(log,'Comment', $event)" [ngClass]="isFranchisee?'disable-class-color':''" matTooltip="Add Comment">comment</mat-icon>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div *ngIf="log?.comments?.length > 0; else noComments">
                                        <ul class="comment-list">
                                            <li *ngFor="let comment of log.comments;let i=index" class="comment-item" [ngClass]="i!==log.comments?.length-1?'mb-2':''">
                                                <div class="comment-header">
                                                    <span class="commenter-name">{{ comment.commenter_name }}</span>
                                                    <span class="comment-date">
                                                        {{ comment.created_at | date: 'MMM d, y, h:mm a' }}
                                                    </span>
                                                </div>
                                                <div class="comment-body">
                                                    {{ comment.comment }}
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <ng-template #noComments>
                                        <p class="no-comments">No comments available.</p>
                                    </ng-template>

                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                        <div class="col-md-12 mt-3">
                            <mat-accordion class="custom-accordion">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title> <span class="title">Attachments</span> <mat-icon
                                                matTooltip="Add Attachment"
                                                (click)="openDialog(log, 'Attachment', $event)"
                                                class="marginLeftCustom" color="primary" [ngClass]="isFranchisee?'disable-class-color':''" matTooltip="Add Attachment">attach_file</mat-icon>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="bids-container">
                                        <ng-container
                                            *ngIf="(log?.photos?.length > 0) || (log?.documents?.length > 0) || (log?.videos?.length > 0);else noAttachments ">

                                            <div class="mt-3" *ngIf="log?.photos?.length > 0">
                                            <h4 class="bg-upl">Uploaded Pictures</h4>
                                                <div class="row rowGap15px py-2 px-2">
                                                    <div *ngFor="let photo of log?.photos" class="col-md-2">
                                                        <div class="dl-images2">
                                                            <ng-container>
                                                                <mat-icon class="delete-icon" id="cross-icon"
                                                                    *ngIf="user_id === log?.created_by"
                                                                    (click)="deleteAttachment(photo,'photo')" [ngClass]="isFranchisee?'disable-class':''">close
                                                                </mat-icon>
                                                            </ng-container>
                                                            <img [src]="photo?.file_path" class="w-full uploaded-img"
                                                                alt="Image 1" />
                                                            <mat-icon (click)="downloadFile(photo)" class="download-icon"
                                                                [ngClass]="isFranchisee?'disable-class':''">get_app</mat-icon>
                                                        </div>
                                                        <p class="mb-0 file-name-style mt-0">
                                                            {{ photo?.file_name }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class=" mt-3" *ngIf="log?.documents?.length > 0">
                                            <h4 class="bg-upl">Uploaded Documents</h4>
                                                <div fxLayout="" fxLayoutGap="10px" class="">
                                                    <div class="bd-files">
                                                        <div fxFlex="8.2"
                                                            *ngFor="let doc of log?.documents; let iDoc = index">
                                                            <div class="dl-images2 dl-images2-pdf">
                                                                <ng-container>
                                                                    <mat-icon class="delete-icon"
                                                                        *ngIf="user_id === log?.created_by"
                                                                        (click)="deleteAttachment(doc,'document')" [ngClass]="isFranchisee?'disable-class':''">close
                                                                    </mat-icon>
                                                                </ng-container>
                                                                <img src="./../../../assets/images/pdf-box.png"
                                                                    alt="" />
                                                                <mat-icon (click)="downloadFile(doc)" class="download-icon"
                                                                    [ngClass]="isFranchisee?'disable-class':''">get_app</mat-icon>
                                                            </div>
                                                            <p class="mb-0 file-name-style">
                                                                {{ doc?.file_name }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class=" mt-3" *ngIf="log?.videos?.length > 0">
                                            <h4 class="bg-upl">Uploaded Videos</h4>
                                                <div fxLayout="flex row" fxLayoutGap="10px" class="">
                                                    <div class="bd-files" *ngFor="let vid of log?.videos">
                                                        <div class="" fxFlex=" 13.2">
                                                            <div class="dl-images2">
                                                                <ng-container>
                                                                    <mat-icon class="delete-icon"
                                                                        *ngIf="user_id === log?.created_by"
                                                                        (click)="deleteAttachment(vid,'video')"
                                                                        [ngClass]="isFranchisee?'disable-class':''">
                                                                        close
                                                                    </mat-icon>
                                                                </ng-container>
                                                                <img width="160"
                                                                    src="./../../../assets/images/video-box.png"
                                                                    alt="" />
                                                                <mat-icon (click)="downloadFile(vid)" class="download-icon"
                                                                    [ngClass]="isFranchisee?'disable-class':''">get_app</mat-icon>
                                                            </div>
                                                            <p class="mb-0 file-name-style">
                                                                {{ vid?.file_name }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </ng-container>
                                        <ng-template #noAttachments>
                                            <p class="text-center">No attachments available.</p>
                                        </ng-template>
                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <div class="" *ngIf="!allLogs || allLogs?.length==0">
        <div class="text-center noDataBox">
            <img src="../../../assets/images/no-data.png" alt="" class="img-fluid" />
            <p class="no-data">No data available</p>
        </div>
    </div>
</div>